






































import { Component, mixins } from '@niknevis/vue-modules'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import { VipGroupCollectionType } from '@/modules/vip-group/models/vip-group-collection.model'
import AdminVipGroupTableRow from '@/modules/vip-group/components/admin/table/AdminVipGroupTableRow.vue'
import { getVipGroupColumnsInAdmin } from '@/modules/vip-group/models/columns/admin-vip-group.column'
import { Filter, FilterTypes } from '@/modules/common/filter/filter'
import AdminUserSearchFilter from '@/modules/user/components/admin/AdminUserSearchFilter.vue'
import AdminVipGroupCreateButton from '@/modules/vip-group/components/admin/AdminVipGroupCreateButton.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'لیست گروه های ویژه'
  },
  metaInfo: {
    title: 'لیست گروه های ویژه'
  },
  components: {
    AdminVipGroupCreateButton,
    TesTable,
    FilterRow,
    PaginationWithInput
  }
})
export default class IndexPage extends mixins(QsPaginatableMixin, QsSearchableMixin) {
  @ProvideReactive()
  @Prop() groups: VipGroupCollectionType
  private rowComponent = AdminVipGroupTableRow
  private columns = getVipGroupColumnsInAdmin()

  private filters = [
    new Filter({
      type: FilterTypes.Custom,
      key: 'users',
      title: 'کاربران',
      typeMode: false,
      props: {
        multiple: true
      },
      component: AdminUserSearchFilter
    })
  ]

  protected get model(): any {
    return this.groups
  }

  private updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }
}
